// import React, { useState, useEffect } from "react";
// import { FiEdit, FiPlus, FiCheckCircle, FiPackage } from "react-icons/fi";

// const Packages = () => {
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showAddForm, setShowAddForm] = useState(false);
//   const [showEditForm, setShowEditForm] = useState(false);
//   const [currentPackage, setCurrentPackage] = useState(null);
//   const [formData, setFormData] = useState({
//     packageName: "",
//     price: "",
//     validity: "",
//     pointOne: "",
//     pointTwo: "",
//     pointThree: "",
//     pointFour: "",
//     pointFive: "",
//     pointSix: "",
//     pointSeven: "",
//     pointEight: "",
//     pointNine: "",
//     pointTen: "",
//   });

//   // Fetch all packages
//   useEffect(() => {
//     fetchPackages();
//   }, []);

//   const fetchPackages = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(
//         `https://octoberfour-60f2c682a1d1.herokuapp.com/packages`
//       );
//       if (!response.ok) {
//         throw new Error("Failed to fetch packages");
//       }
//       const data = await response.json();
//       setPackages(data);
//       setError(null);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch a single package
//   const fetchPackage = async (id) => {
//     try {
//       const response = await fetch(
//         `https://octoberfour-60f2c682a1d1.herokuapp.com/package/${id}`
//       );
//       if (!response.ok) {
//         throw new Error("Failed to fetch package");
//       }
//       const data = await response.json();
//       setCurrentPackage(data);
//       setFormData(data);
//       setShowEditForm(true);
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   // Add a new package
//   const addPackage = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(
//         "https://octoberfour-60f2c682a1d1.herokuapp.com/add-package",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Failed to add package");
//       }

//       setShowAddForm(false);
//       setFormData({
//         packageName: "",
//         price: "",
//         validity: "",
//         pointOne: "",
//         pointTwo: "",
//         pointThree: "",
//         pointFour: "",
//         pointFive: "",
//         pointSix: "",
//         pointSeven: "",
//         pointEight: "",
//         pointNine: "",
//         pointTen: "",
//       });
//       fetchPackages();
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   // Update a package
//   const updatePackage = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(
//         `https://octoberfour-60f2c682a1d1.herokuapp.com/edit-package/${currentPackage._id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Failed to update package");
//       }

//       setShowEditForm(false);
//       setCurrentPackage(null);
//       fetchPackages();
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   // Handle form input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Render package features as list items
//   const renderFeatures = (pkg) => {
//     const features = [
//       pkg.pointOne,
//       pkg.pointTwo,
//       pkg.pointThree,
//       pkg.pointFour,
//       pkg.pointFive,
//       pkg.pointSix,
//       pkg.pointSeven,
//       pkg.pointEight,
//       pkg.pointNine,
//       pkg.pointTen,
//     ].filter(Boolean);

//     return features.map((feature, index) => (
//       <li key={index} className="mb-2">
//         <FiCheckCircle className="text-success me-2" />
//         {feature}
//       </li>
//     ));
//   };

//   return (
//     <div className="container py-5">
//       {/* Header */}
//       <div className="row mb-4">
//         <div className="col d-flex justify-content-between align-items-center">
//           <h2 className="fw-bold text-light">
//             <FiPackage className="me-2" />
//             Pricing Packages
//           </h2>
//           <button
//             className="btn btn-primary"
//             onClick={() => setShowAddForm(true)}
//             disabled={packages.length >= 3}
//             title={packages.length >= 3 ? "Maximum 3 packages allowed" : ""}
//           >
//             <FiPlus className="me-1" /> Add Package
//           </button>
//         </div>
//       </div>

//       {/* Error Alert */}
//       {error && (
//         <div className="alert alert-danger" role="alert">
//           {error}
//         </div>
//       )}

//       {/* Loading Spinner */}
//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//           <p className="mt-3">Loading packages...</p>
//         </div>
//       ) : (
//         <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
//           {packages.map((pkg) => (
//             <div key={pkg._id} className="col">
//               <div className="card h-100 shadow-sm">
//                 <div className="card-header bg-primary text-white text-center py-3">
//                   <h3 className="mb-0">{pkg.packageName}</h3>
//                 </div>
//                 <div className="card-body d-flex flex-column">
//                   <div className="text-center mb-4">
//                     <h2 className="display-5 fw-bold">${pkg.price}</h2>
//                     {/* <p className="text-muted">{pkg.validity}</p> */}
//                   </div>
//                   <ul className="list-unstyled mb-4">{renderFeatures(pkg)}</ul>
//                   <div className="mt-auto text-center">
//                     <button
//                       className="btn btn-outline-primary"
//                       onClick={() => fetchPackage(pkg._id)}
//                     >
//                       <FiEdit className="me-1" /> Edit
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}

//           {packages.length === 0 && !loading && (
//             <div className="col-12 text-center py-5">
//               <p className="text-muted">
//                 No packages available. Add a new package to get started.
//               </p>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Add Package Form */}
//       {showAddForm && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           role="dialog"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-lg" role="document">
//             <div className="modal-content">
//               <div className="modal-header bg-primary text-white">
//                 <h5 className="modal-title">Add New Package</h5>
//                 <button
//                   type="button"
//                   className="btn-close btn-close-white"
//                   onClick={() => setShowAddForm(false)}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <form onSubmit={addPackage}>
//                   <div className="row g-3">
//                     <div className="col-md-6">
//                       <label htmlFor="packageName" className="form-label">
//                         Package Name
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="packageName"
//                         name="packageName"
//                         value={formData.packageName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       <label htmlFor="price" className="form-label">
//                         Price
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="price"
//                         name="price"
//                         value={formData.price}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       {/* <label htmlFor="validity" className="form-label">
//                         Validity
//                       </label> */}
//                       <input
//                         hidden
//                         type="text"
//                         className="form-control"
//                         id="validity"
//                         name="validity"
//                         value={formData.validity}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointOne" className="form-label">
//                         Feature 1
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointOne"
//                         name="pointOne"
//                         value={formData.pointOne}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTwo" className="form-label">
//                         Feature 2
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTwo"
//                         name="pointTwo"
//                         value={formData.pointTwo}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointThree" className="form-label">
//                         Feature 3
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointThree"
//                         name="pointThree"
//                         value={formData.pointThree}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFour" className="form-label">
//                         Feature 4
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFour"
//                         name="pointFour"
//                         value={formData.pointFour}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFive" className="form-label">
//                         Feature 5
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFive"
//                         name="pointFive"
//                         value={formData.pointFive}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSix" className="form-label">
//                         Feature 6
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSix"
//                         name="pointSix"
//                         value={formData.pointSix}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSeven" className="form-label">
//                         Feature 7
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSeven"
//                         name="pointSeven"
//                         value={formData.pointSeven}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointEight" className="form-label">
//                         Feature 8
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointEight"
//                         name="pointEight"
//                         value={formData.pointEight}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointNine" className="form-label">
//                         Feature 9
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointNine"
//                         name="pointNine"
//                         value={formData.pointNine}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTen" className="form-label">
//                         Feature 10
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTen"
//                         name="pointTen"
//                         value={formData.pointTen}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="mt-4 d-flex justify-content-end">
//                     <button
//                       type="button"
//                       className="btn btn-secondary me-2"
//                       onClick={() => setShowAddForm(false)}
//                     >
//                       Cancel
//                     </button>
//                     <button type="submit" className="btn btn-primary">
//                       Save Package
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Package Form */}
//       {showEditForm && currentPackage && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           role="dialog"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-lg" role="document">
//             <div className="modal-content">
//               <div className="modal-header bg-primary text-white">
//                 <h5 className="modal-title">Edit Package</h5>
//                 <button
//                   type="button"
//                   className="btn-close btn-close-white"
//                   onClick={() => setShowEditForm(false)}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <form onSubmit={updatePackage}>
//                   <div className="row g-3">
//                     <div className="col-md-6">
//                       <label htmlFor="packageName" className="form-label">
//                         Package Name
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="packageName"
//                         name="packageName"
//                         value={formData.packageName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       <label htmlFor="price" className="form-label">
//                         Price
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="price"
//                         name="price"
//                         value={formData.price}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       {/* <label htmlFor="validity" className="form-label">
//                         Validity
//                       </label> */}
//                       <input
//                         hidden
//                         type="text"
//                         className="form-control"
//                         id="validity"
//                         name="validity"
//                         value={formData.validity}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointOne" className="form-label">
//                         Feature 1
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointOne"
//                         name="pointOne"
//                         value={formData.pointOne}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTwo" className="form-label">
//                         Feature 2
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTwo"
//                         name="pointTwo"
//                         value={formData.pointTwo}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointThree" className="form-label">
//                         Feature 3
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointThree"
//                         name="pointThree"
//                         value={formData.pointThree}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFour" className="form-label">
//                         Feature 4
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFour"
//                         name="pointFour"
//                         value={formData.pointFour}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFive" className="form-label">
//                         Feature 5
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFive"
//                         name="pointFive"
//                         value={formData.pointFive}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSix" className="form-label">
//                         Feature 6
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSix"
//                         name="pointSix"
//                         value={formData.pointSix}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSeven" className="form-label">
//                         Feature 7
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSeven"
//                         name="pointSeven"
//                         value={formData.pointSeven}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointEight" className="form-label">
//                         Feature 8
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointEight"
//                         name="pointEight"
//                         value={formData.pointEight}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointNine" className="form-label">
//                         Feature 9
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointNine"
//                         name="pointNine"
//                         value={formData.pointNine}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTen" className="form-label">
//                         Feature 10
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTen"
//                         name="pointTen"
//                         value={formData.pointTen}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="mt-4 d-flex justify-content-end">
//                     <button
//                       type="button"
//                       className="btn btn-secondary me-2"
//                       onClick={() => setShowEditForm(false)}
//                     >
//                       Cancel
//                     </button>
//                     <button type="submit" className="btn btn-primary">
//                       Update Package
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Packages;

// import React, { useState, useEffect } from "react";
// import { FiEdit, FiPlus, FiCheckCircle, FiPackage } from "react-icons/fi";

// const Packages = () => {
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showAddForm, setShowAddForm] = useState(false);
//   const [showEditForm, setShowEditForm] = useState(false);
//   const [currentPackage, setCurrentPackage] = useState(null);
//   const [formData, setFormData] = useState({
//     packageName: "",
//     price: "",
//     validity: "",
//     credit: "", // Added credit field
//     pointOne: "",
//     pointTwo: "",
//     pointThree: "",
//     pointFour: "",
//     pointFive: "",
//     pointSix: "",
//     pointSeven: "",
//     pointEight: "",
//     pointNine: "",
//     pointTen: "",
//   });

//   // Fetch all packages
//   useEffect(() => {
//     fetchPackages();
//   }, []);

//   const fetchPackages = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(`https://octoberfour-60f2c682a1d1.herokuapp.com/packages`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch packages");
//       }
//       const data = await response.json();
//       setPackages(data);
//       setError(null);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch a single package
//   const fetchPackage = async (id) => {
//     try {
//       const response = await fetch(`https://octoberfour-60f2c682a1d1.herokuapp.com/package/${id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch package");
//       }
//       const data = await response.json();
//       setCurrentPackage(data);
//       setFormData(data);
//       setShowEditForm(true);
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   // Add a new package
//   const addPackage = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/add-package", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });
//       if (!response.ok) {
//         throw new Error("Failed to add package");
//       }
//       setShowAddForm(false);
//       setFormData({
//         packageName: "",
//         price: "",
//         validity: "",
//         credit: "", // Reset credit field
//         pointOne: "",
//         pointTwo: "",
//         pointThree: "",
//         pointFour: "",
//         pointFive: "",
//         pointSix: "",
//         pointSeven: "",
//         pointEight: "",
//         pointNine: "",
//         pointTen: "",
//       });
//       fetchPackages();
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   // Update a package
//   const updatePackage = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(
//         `https://octoberfour-60f2c682a1d1.herokuapp.com/edit-package/${currentPackage._id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         }
//       );
//       if (!response.ok) {
//         throw new Error("Failed to update package");
//       }
//       setShowEditForm(false);
//       setCurrentPackage(null);
//       fetchPackages();
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   // Handle form input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Render package features as list items
//   const renderFeatures = (pkg) => {
//     const features = [
//       pkg.pointOne,
//       pkg.pointTwo,
//       pkg.pointThree,
//       pkg.pointFour,
//       pkg.pointFive,
//       pkg.pointSix,
//       pkg.pointSeven,
//       pkg.pointEight,
//       pkg.pointNine,
//       pkg.pointTen,
//     ].filter(Boolean);
//     return features.map((feature, index) => (
//       <li key={index} className="mb-2">
//         <FiCheckCircle className="text-success me-2" />
//         {feature}
//       </li>
//     ));
//   };

//   return (
//     <div className="container py-5">
//       {/* Header */}
//       <div className="row mb-4">
//         <div className="col d-flex justify-content-between align-items-center">
//           <h2 className="fw-bold text-black ">
//             <FiPackage className="me-2 " />
//             Pricing Packages
//           </h2>
//           <button
//             className="btn btn-primary"
//             onClick={() => setShowAddForm(true)}
//             disabled={packages.length >= 3}
//             title={packages.length >= 3 ? "Maximum 3 packages allowed" : ""}
//           >
//             <FiPlus className="me-1" /> Add Package
//           </button>
//         </div>
//       </div>

//       {/* Error Alert */}
//       {error && (
//         <div className="alert alert-danger" role="alert">
//           {error}
//         </div>
//       )}

//       {/* Loading Spinner */}
//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//           <p className="mt-3">Loading packages...</p>
//         </div>
//       ) : (
//         <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
//           {packages.map((pkg) => (
//             <div key={pkg._id} className="col">
//               <div className="card h-100 shadow-sm">
//                 <div className="card-header bg-primary text-white text-center py-3">
//                   <h3 className="mb-0">{pkg.packageName}</h3>
//                 </div>
//                 <div className="card-body d-flex flex-column">
//                   <div className="text-center mb-4">
//                     <h2 className="display-5 fw-bold">${pkg.price}</h2>
//                     <p className="text-muted">{pkg.credit} Credits</p>
//                   </div>
//                   <ul className="list-unstyled mb-4">{renderFeatures(pkg)}</ul>
//                   <div className="mt-auto text-center">
//                     <button
//                       className="btn btn-outline-primary"
//                       onClick={() => fetchPackage(pkg._id)}
//                     >
//                       <FiEdit className="me-1" /> Edit
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//           {packages.length === 0 && !loading && (
//             <div className="col-12 text-center py-5">
//               <p className="text-muted">
//                 No packages available. Add a new package to get started.
//               </p>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Add Package Form */}
//       {showAddForm && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           role="dialog"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-lg" role="document">
//             <div className="modal-content">
//               <div className="modal-header bg-primary text-white">
//                 <h5 className="modal-title">Add New Package</h5>
//                 <button
//                   type="button"
//                   className="btn-close btn-close-white"
//                   onClick={() => setShowAddForm(false)}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <form onSubmit={addPackage}>
//                   <div className="row g-3">
//                     <div className="col-md-6">
//                       <label htmlFor="packageName" className="form-label">
//                         Package Name
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="packageName"
//                         name="packageName"
//                         value={formData.packageName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       <label htmlFor="price" className="form-label">
//                         Price
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="price"
//                         name="price"
//                         value={formData.price}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       <label htmlFor="credit" className="form-label">
//                         Credits
//                       </label>
//                       <input
//                         type="number"
//                         className="form-control"
//                         id="credit"
//                         name="credit"
//                         value={formData.credit}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointOne" className="form-label">
//                         Feature 1
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointOne"
//                         name="pointOne"
//                         value={formData.pointOne}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTwo" className="form-label">
//                         Feature 2
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTwo"
//                         name="pointTwo"
//                         value={formData.pointTwo}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointThree" className="form-label">
//                         Feature 3
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointThree"
//                         name="pointThree"
//                         value={formData.pointThree}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFour" className="form-label">
//                         Feature 4
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFour"
//                         name="pointFour"
//                         value={formData.pointFour}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFive" className="form-label">
//                         Feature 5
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFive"
//                         name="pointFive"
//                         value={formData.pointFive}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSix" className="form-label">
//                         Feature 6
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSix"
//                         name="pointSix"
//                         value={formData.pointSix}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSeven" className="form-label">
//                         Feature 7
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSeven"
//                         name="pointSeven"
//                         value={formData.pointSeven}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointEight" className="form-label">
//                         Feature 8
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointEight"
//                         name="pointEight"
//                         value={formData.pointEight}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointNine" className="form-label">
//                         Feature 9
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointNine"
//                         name="pointNine"
//                         value={formData.pointNine}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTen" className="form-label">
//                         Feature 10
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTen"
//                         name="pointTen"
//                         value={formData.pointTen}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="mt-4 d-flex justify-content-end">
//                     <button
//                       type="button"
//                       className="btn btn-secondary me-2"
//                       onClick={() => setShowAddForm(false)}
//                     >
//                       Cancel
//                     </button>
//                     <button type="submit" className="btn btn-primary">
//                       Save Package
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Package Form */}
//       {showEditForm && currentPackage && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           role="dialog"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-lg" role="document">
//             <div className="modal-content">
//               <div className="modal-header bg-primary text-white">
//                 <h5 className="modal-title">Edit Package</h5>
//                 <button
//                   type="button"
//                   className="btn-close btn-close-white"
//                   onClick={() => setShowEditForm(false)}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <form onSubmit={updatePackage}>
//                   <div className="row g-3">
//                     <div className="col-md-6">
//                       <label htmlFor="packageName" className="form-label">
//                         Package Name
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="packageName"
//                         name="packageName"
//                         value={formData.packageName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       <label htmlFor="price" className="form-label">
//                         Price
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="price"
//                         name="price"
//                         value={formData.price}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       <label htmlFor="credit" className="form-label">
//                         Credits
//                       </label>
//                       <input
//                         type="number"
//                         className="form-control"
//                         id="credit"
//                         name="credit"
//                         value={formData.credit}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointOne" className="form-label">
//                         Feature 1
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointOne"
//                         name="pointOne"
//                         value={formData.pointOne}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTwo" className="form-label">
//                         Feature 2
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTwo"
//                         name="pointTwo"
//                         value={formData.pointTwo}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointThree" className="form-label">
//                         Feature 3
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointThree"
//                         name="pointThree"
//                         value={formData.pointThree}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFour" className="form-label">
//                         Feature 4
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFour"
//                         name="pointFour"
//                         value={formData.pointFour}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFive" className="form-label">
//                         Feature 5
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFive"
//                         name="pointFive"
//                         value={formData.pointFive}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSix" className="form-label">
//                         Feature 6
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSix"
//                         name="pointSix"
//                         value={formData.pointSix}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSeven" className="form-label">
//                         Feature 7
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSeven"
//                         name="pointSeven"
//                         value={formData.pointSeven}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointEight" className="form-label">
//                         Feature 8
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointEight"
//                         name="pointEight"
//                         value={formData.pointEight}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointNine" className="form-label">
//                         Feature 9
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointNine"
//                         name="pointNine"
//                         value={formData.pointNine}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTen" className="form-label">
//                         Feature 10
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTen"
//                         name="pointTen"
//                         value={formData.pointTen}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="mt-4 d-flex justify-content-end">
//                     <button
//                       type="button"
//                       className="btn btn-secondary me-2"
//                       onClick={() => setShowEditForm(false)}
//                     >
//                       Cancel
//                     </button>
//                     <button type="submit" className="btn btn-primary">
//                       Update Package
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Packages;


import React, { useState, useEffect } from "react";
import { FiEdit, FiPlus, FiCheckCircle, FiPackage } from "react-icons/fi";

const Packages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [currentPackage, setCurrentPackage] = useState(null);
  const [formData, setFormData] = useState({
    packageName: "",
    price: "",
    validity: "",
    credit: "",
    accessURL: "",
    pointOne: "",
    pointTwo: "",
    pointThree: "",
    pointFour: "",
    pointFive: "",
    pointSix: "",
    pointSeven: "",
    pointEight: "",
    pointNine: "",
    pointTen: "",
  });

  // Fetch all packages
  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    setLoading(true);
    try {
      const response = await fetch(`https://octoberfour-60f2c682a1d1.herokuapp.com/packages`);
      if (!response.ok) throw new Error("Failed to fetch packages");
      const data = await response.json();
      setPackages(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch single package for edit
  const fetchPackage = async (id) => {
    try {
      const response = await fetch(`https://octoberfour-60f2c682a1d1.herokuapp.com/package/${id}`);
      if (!response.ok) throw new Error("Failed to fetch package");
      const data = await response.json();
      setCurrentPackage(data);
      setFormData(data);
      setShowEditForm(true);
    } catch (err) {
      setError(err.message);
    }
  };

  // Handle Add package
  const addPackage = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://octoberfour-60f2c682a1d1.herokuapp.com/add-package", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error("Failed to add package");
      setShowAddForm(false);
      resetForm();
      fetchPackages();
    } catch (err) {
      setError(err.message);
    }
  };

  // Handle Update package
  const updatePackage = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `https://octoberfour-60f2c682a1d1.herokuapp.com/edit-package/${currentPackage._id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );
      if (!response.ok) throw new Error("Failed to update package");
      setShowEditForm(false);
      setCurrentPackage(null);
      fetchPackages();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      packageName: "",
      price: "",
      validity: "",
      credit: "",
      accessURL: "",
      pointOne: "",
      pointTwo: "",
      pointThree: "",
      pointFour: "",
      pointFive: "",
      pointSix: "",
      pointSeven: "",
      pointEight: "",
      pointNine: "",
      pointTen: "",
    });
  };

  const renderFeatures = (pkg) => {
    const features = [
      pkg.pointOne,
      pkg.pointTwo,
      pkg.pointThree,
      pkg.pointFour,
      pkg.pointFive,
      pkg.pointSix,
      pkg.pointSeven,
      pkg.pointEight,
      pkg.pointNine,
      pkg.pointTen,
    ].filter(Boolean);
    return features.map((feature, idx) => (
      <li key={idx} className="mb-2">
        <FiCheckCircle className="text-success me-2" />
        {feature}
      </li>
    ));
  };

  return (
    <div className="container py-5">
      {/* Header */}
      <div className="row mb-4">
        <div className="col d-flex justify-content-between align-items-center">
          <h2 className="fw-bold text-black">
            <FiPackage className="me-2" />
            Pricing Packages
          </h2>
          <button
            className="btn btn-primary"
            onClick={() => setShowAddForm(true)}
            disabled={packages.length >= 3}
            title={packages.length >= 3 ? "Maximum 3 packages allowed" : ""}
          >
            <FiPlus className="me-1" /> Add Package
          </button>
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-3">Loading packages...</p>
        </div>
      ) : (
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          {packages.map((pkg) => (
            <div key={pkg._id} className="col">
              <div className="card h-100 shadow-sm">
                <div className="card-header bg-primary text-white text-center py-3">
                  <h3 className="mb-0">{pkg.packageName}</h3>
                </div>
                <div className="card-body d-flex flex-column">
                  <div className="text-center mb-4">
                    <h2 className="display-5 fw-bold text-black">${pkg.price}</h2>
                  </div>

                  <ul className="list-unstyled mb-4">{renderFeatures(pkg)}</ul>

                  {pkg.accessURL && (
                    <div className="text-center mb-3">
                      <a
                        href={pkg.accessURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-outline-success"
                      >
                        Access Link
                      </a>
                    </div>
                  )}

                  <div className="mt-auto text-center">
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => fetchPackage(pkg._id)}
                    >
                      <FiEdit className="me-1" /> Edit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {packages.length === 0 && !loading && (
            <div className="col-12 text-center py-5">
              <p className="text-muted">No packages available. Add a new package to get started.</p>
            </div>
          )}
        </div>
      )}

      {/* Add/Edit Forms */}
      {(showAddForm || showEditForm) && (
        <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">{showAddForm ? "Add New Package" : "Edit Package"}</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => {
                    setShowAddForm(false);
                    setShowEditForm(false);
                    setCurrentPackage(null);
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={showAddForm ? addPackage : updatePackage}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Package Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="packageName"
                        value={formData.packageName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Price</label>
                      <input
                        type="text"
                        className="form-control"
                        name="price"
                        value={formData.price}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Credits</label>
                      <input
                        type="number"
                        className="form-control"
                        name="credit"
                        value={formData.credit}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-12">
                      <label className="form-label">Access URL</label>
                      <input
                        type="text"
                        className="form-control"
                        name="accessURL"
                        value={formData.accessURL}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Features 1-10 */}
                    {[...Array(10)].map((_, i) => (
                      <div className="col-md-6" key={i}>
                        <label className="form-label">Feature {i + 1}</label>
                        <input
                          type="text"
                          className="form-control"
                          name={`point${["One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten"][i]}`}
                          value={formData[`point${["One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten"][i]}`]}
                          onChange={handleChange}
                        />
                      </div>
                    ))}
                  </div>

                  <div className="mt-4 d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => {
                        setShowAddForm(false);
                        setShowEditForm(false);
                        setCurrentPackage(null);
                      }}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                      {showAddForm ? "Save Package" : "Update Package"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Packages;